import { createElement, type ReactNode } from 'react';
import { useFela } from 'react-fela';

import type { Theme } from '@/styles/theme';

import { container, type HeadingVariant } from './Heading.rules';

export interface HeadingProps {
    elementType?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
    color?: keyof Theme['colors'];
    variant?: HeadingVariant;
    customStyle?: typeof container;
    children: ReactNode;
}

export const Heading = ({ elementType = 'h1', color, variant = 'h2', customStyle, children }: HeadingProps) => {
    const { css } = useFela({ color, variant });

    return createElement(elementType, { className: `Heading ${css(container, customStyle)}` }, children);
};
